module.exports = __webpack_public_path__ + "img/pic_1_zh_new.ee5e0151.png";